import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './Dialog';
import { Input } from './Input';
import { Check, Mail, Play } from 'lucide-react';
interface RegistrationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}
export function RegistrationModal({
  isOpen,
  onOpenChange
}: RegistrationModalProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onOpenChange(false);
  };
  const bullets = [<>
      For new <span className="text-brand-gold italic" data-id="element-108">and</span> experienced
      investors
    </>, <>Ready to land your first 6 to 7 figure payday</>, <>Will attend the live 90-minute session</>];
  return <Dialog open={isOpen} onOpenChange={onOpenChange} data-id="element-109">
      <DialogContent className="sm:max-w-[460px] bg-brand-navy border-brand-gold/30 text-white p-6 md:p-8 max-h-[90vh] overflow-y-auto" data-id="element-110">
        {/* Accessible-only title/description */}
        <DialogTitle className="sr-only" data-id="element-111">Reserve your free seat</DialogTitle>
        <DialogDescription className="sr-only" data-id="element-112">
          Register for the free 90-minute commercial real estate workshop on
          Zoom.
        </DialogDescription>

        {/* Live on Zoom badge */}
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-113">
          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-600" data-id="element-114">
            <Play className="w-2.5 h-2.5 fill-white text-white" data-id="element-115" />
          </span>
          <span className="font-display font-bold text-white text-sm tracking-wider uppercase" data-id="element-116">
            Live On
          </span>
          <span className="font-bold text-[#2D8CFF] text-xl leading-none" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-117">
            Zoom
          </span>
        </div>

        {/* Headline stack */}
        <div className="text-center mb-6" data-id="element-118">
          <p className="font-display text-brand-gold uppercase tracking-[0.2em] text-[11px] font-bold mb-3" data-id="element-119">
            Bigger Profits Workshop
          </p>
          <h2 className="font-display font-bold uppercase text-white leading-[1.05]" data-id="element-120">
            <span className="block text-3xl md:text-4xl" data-id="element-121">Reserve Your</span>
            <span className="block text-3xl md:text-4xl" data-id="element-122">
              <span className="italic text-brand-gold" data-id="element-123">Free</span> Seat
            </span>
          </h2>
          <p className="font-body text-white/90 text-sm md:text-base mt-3" data-id="element-124">
            Wednesday, May 20th at 6PM EST
          </p>
        </div>

        {/* Seats counter */}
        <div className="flex items-center justify-center gap-2 rounded-full px-4 py-2.5 mb-5" style={{
        backgroundColor: '#061A42',
        border: '1px solid rgba(201, 167, 70, 0.5)'
      }} data-id="element-125">
          <span className="relative flex h-2 w-2" data-id="element-126">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75" data-id="element-127"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold" data-id="element-128"></span>
          </span>
          <span className="font-display italic font-bold text-brand-gold uppercase text-xs md:text-sm tracking-wider" data-id="element-129">
            40 of 100 Seats Remaining
          </span>
        </div>

        {/* Bullets */}
        <ul className="space-y-2.5 mb-5" data-id="element-130">
          {bullets.map((b, i) => <li key={i} className="flex items-center gap-3" data-id="element-131">
              <span className="flex-shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-gold" data-id="element-132">
                <Check className="w-3 h-3 text-white" strokeWidth={3.5} data-id="element-133" />
              </span>
              <span className="font-body italic font-semibold text-white text-sm" data-id="element-134">
                {b}
              </span>
            </li>)}
        </ul>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-3" data-id="element-135">
          <Input required placeholder="Full Name*" className="bg-white border-0 text-gray-900 placeholder:text-gray-500 h-11 rounded-lg" data-id="element-136" />

          <div className="relative" data-id="element-137">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-138" />
            <Input required type="email" placeholder="Email*" className="bg-white border-0 text-gray-900 placeholder:text-gray-500 h-11 rounded-lg pl-10" data-id="element-139" />
          </div>

          <Input required type="tel" placeholder="Phone*" className="bg-white border-0 text-gray-900 placeholder:text-gray-500 h-11 rounded-lg" data-id="element-140" />

          {/* Compliance */}
          <label className="flex items-start gap-2 pt-1 cursor-pointer" data-id="element-141">
            <input type="checkbox" required className="mt-0.5 w-4 h-4 rounded border-gray-400 accent-brand-gold flex-shrink-0" data-id="element-142" />
            <span className="font-body text-[11px] leading-snug text-gray-300" data-id="element-143">
              By submitting, you agree to receive event updates from Bigger
              Profits. Msg &amp; data rates may apply.
            </span>
          </label>

          <button type="submit" className="w-full mt-2 rounded-full bg-brand-gold hover:bg-[#d4b455] text-black font-display font-bold uppercase text-base md:text-lg tracking-wider py-3.5 transition-all hover:shadow-[0_0_18px_rgba(201,167,70,0.6)]" data-id="element-144">
            Reserve My Free Seat
          </button>
        </form>
      </DialogContent>
    </Dialog>;
}